import { FC } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { truncateText } from '@/utils/truncateText';

type TruncatedTextWithTooltipProps = {
  text: string;
  maxLength: number;
};

const TruncatedTextWithTooltip: FC<TruncatedTextWithTooltipProps> = ({
  text,
  maxLength,
}) => {
  return (
    <>
      <Tooltip target=".TruncatedTextWithTooltip" position="top" />
      <span className="TruncatedTextWithTooltip" data-pr-tooltip={text}>
        {truncateText(text, maxLength)}
      </span>
    </>
  );
};

export default TruncatedTextWithTooltip;
